import { onOptInExperienceCompletedForScenarioMutator } from 'owa-copilot-settings-store';
import type { MailboxInfo } from 'owa-client-types';

export default function onPrioritizeOptInExperienceCompleted(mailboxInfo: MailboxInfo): void {
    onOptInExperienceCompletedForScenarioMutator('Inbox', mailboxInfo);
}
